import { createResource, type RouteResource } from 'react-resource-router';

import type { UiPreferences } from '../../../common/types';
import { getUiPreferencesEndpoint } from '../endpoints';

export const uiPreferencesResource: RouteResource<UiPreferences> = createResource<UiPreferences>({
	type: 'uiPreferencesResource',
	getKey: () => 'uiPreferencesResource',
	getData: () => getUiPreferencesEndpoint(),
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
